import { render, staticRenderFns } from "./RequestDiagnosticsModal.vue?vue&type=template&id=f893229e&"
import script from "./RequestDiagnosticsModal.vue?vue&type=script&lang=js&"
export * from "./RequestDiagnosticsModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestDiagnosticsModal.vue?vue&type=style&index=0&id=f893229e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports